export default __webpack_public_path__ + "static/media/no-chall-found.f5ce7705.png";